import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { object, string } from "yup";

import {
  LocationChoices,
  PositionLocationInputField,
} from "./PositionLocationInputField";
import { PositionLocationSummaryField } from "./PositionLocationSummaryField";
import { addressSchema } from "../../../../components/AddressInput";
import { FieldType } from "../types";

export function PositionLocationField(
  field: components["schemas"]["PositionOrPropertyLocationCheckField"]
): FieldType<components["schemas"]["PositionOrPropertyLocationCheckField"]> {
  return {
    field,
    inputElement: <PositionLocationInputField key={field.name} field={field} />,
    summaryElement: () => (
      <PositionLocationSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value || {
      location_type: undefined,
    },
    schema: positionLocationFieldSchema,
  };
}

export const positionLocationFieldSchema = object()
  .shape({
    location_type: string(),
    choice: string().when(["location_type"], ([locationType], schema) => {
      if (!locationType) {
        return schema.required(t("This field is required"));
      }
      return schema;
    }),
  })
  .when((values, schema) => {
    const choice = values[0]?.choice;
    // don't validate Address fields if they've select no
    if (!choice || choice === LocationChoices.NO) return schema;
    return schema.concat(addressSchema);
  });
